export default "../images/images/favicon.ico";